<template>
  <div class="containerGeralNfe">
    <div class="title">
      <span>
        <b-icon-file-earmark-medical></b-icon-file-earmark-medical>
        NFC-e
      </span>
      <b-button class="btnsSave" @click="openModals('modalTaxInformation')">
        + Nova Ref. Fiscal
      </b-button>
    </div>
    <div class="rowContainer">
      <span>
        <b-icon-person-lines-fill></b-icon-person-lines-fill> Informações
        Gerais</span
      >
      <div class="rowContent" style="padding: 20px 0 5px 0 !important">
        <b-form-group hidden>
          <b-form-input
            hidden
            type="text"
            size="sm"
            v-model="dadosNfe.id"
          ></b-form-input>
        </b-form-group>
        <div style="width: 45%">
          <InputInfinit
            label="Cliente"
            typeFilter="customer"
            :isEdit="dadosNfe.idCliente"
            :dataInput.sync="dadosNfe.idCliente"
            :onSearch="fillCustomerComboBoxWithPaginate"
            :openCreateModal="() => openModals('modalCreateCustomer')"
            :clearSelected="newOrder"
            :findAll="createdNewCustomer"
            outsideFilterType="start"
            @selectItem="handleDataCustomers($event)"
          />
        </div>

        <div class="input-group" style="width: 13%">
          <input
            type="datetime-local"
            class="input borderInput"
            style="transform: none !important"
            v-model="dadosNfe.data_nfe"
          />
          <label class="fixedSelect" style="transform: none !important">
            Data de Emissão
          </label>
        </div>
        <div class="input-group" style="width: 20% !important">
          <input
            required
            class="input borderInput"
            v-model="dadosNfe.natureza_operacao"
          />
          <label class="user-label"> Natureza operação </label>
        </div>
        <div class="selectPlusSm">
          <label class="user-label-disabled">Ambiente</label>
          <b-form-select
            class="borderInput shadow-none"
            value-field="value"
            text-field="text"
            v-model="dadosNfe.ambiente"
            :options="ambiente"
          >
          </b-form-select>
        </div>
      </div>
      <div class="rowContent">
        <div class="input-group" style="width: 10% !important">
          <input
            class="input borderInput"
            disabled
            v-model="responseNfeWebMania.nfe"
          />
          <label class="user-label-disabled"> Nº </label>
        </div>
        <div class="input-group" style="width: 10% !important">
          <input
            class="input borderInput"
            disabled
            v-model="responseNfeWebMania.serie"
          />
          <label class="user-label-disabled"> Serie </label>
        </div>
        <div class="input-group" style="width: 60% !important">
          <input
            class="input borderInput"
            disabled
            v-model="responseNfeWebMania.chave"
          />
          <label class="user-label-disabled"> Chave </label>
        </div>
        <div class="input-group" style="width: 20% !important">
          <input class="input borderInput" disabled v-model="dadosNfe.status" />
          <label class="user-label-disabled"> Status </label>
        </div>
      </div>
    </div>

    <b-card-text class="mt-3" :hidden="dadosNfe.operacao == '0' ? true : false">
      <div>
        <b-navbar toggleable class="cardDadosNfe">
          <b-navbar-toggle
            target="navbar-toggle-collapse-produtos"
            id="dadosNfeStyle"
            class="tamanhoCards"
          >
            <template #default="{ expanded }">
              <div @click="clickProductAndSave" class="tamanhoBotaoOpenCard">
                <div>
                  <b-icon
                    v-if="expanded"
                    icon="dash-square-fill"
                    style="color: #00395d"
                  ></b-icon>
                  <b-icon v-else icon="plus-square-fill" style="color: #00395d">
                  </b-icon>
                </div>
                <div style="margin-left: 10px; font-size: 13px">
                  Adicionar Produto
                </div>
              </div>
            </template>
          </b-navbar-toggle>

          <b-collapse
            id="navbar-toggle-collapse-produtos"
            class="col-md-12 col-sm-12 col-lg-12 col-xl-12"
            is-nav
          >
            <b-navbar-nav class="ml-auto">
              <b-card class="mt-2 cardDadosNfeBorda">
                <div class="rowContent">
                  <div
                    style="padding: 0px !important; width: 65% !important"
                    class="col-sm-6 col-md-6 col-lg-5 col-xl-6"
                  >
                    <InputInfinit
                      label="Produtos"
                      typeFilter="itens"
                      :isEdit="produtosNotaFiscal.id"
                      :dataInput.sync="produtosNotaFiscal.idProduto"
                      :onSearch="fillProductsComboBoxWithPaginate"
                      :openCreateModal="
                        () =>
                          handleModalCreateProduct(
                            'modalCreateProduct',
                            produtosNotaFiscal.idProduto
                          )
                      "
                      :findAll="createdNewProducts"
                      :clearSelected="toggleClearSelect"
                      :searchFields="['nome', 'codRef']"
                      @selectItem="assignValuesToTheSelectedProduct"
                    />
                  </div>

                  <div class="input-group" style="width: 15% !important">
                    <input
                      required
                      class="input borderInput"
                      v-model="produtosNotaFiscal.ncm"
                    />
                    <label
                      class="fixedSelect"
                      style="transform: none !important"
                    >
                      NCM
                    </label>
                  </div>
                  <div class="selectPlus">
                    <label class="fixedSelect2">Unidade</label>
                    <b-form-select
                      class="borderInput shadow-none"
                      value-field="value"
                      text-field="text"
                      :options="unidade"
                      v-model="produtosNotaFiscal.unidade"
                    >
                    </b-form-select>
                  </div>
                  <div class="input-group" style="width: 15% !important">
                    <input
                      required
                      class="input borderInput"
                      v-model="produtosNotaFiscal.codigo"
                      disabled
                    />
                    <label class="user-label-disabled"> Cod. Ref </label>
                  </div>
                </div>
                <div
                  class="rowContent"
                  style="align-items: center; position: relative"
                >
                  <div style="width: 40%">
                    <InputSelect
                      style="width: 100%"
                      label="REF Fiscal"
                      valueField="ref"
                      textField="descricao"
                      :items="allRefsFiscaisFromSelectBox"
                      :dataSelect.sync="produtosNotaFiscal.classe_imposto"
                      labelFixed="true"
                      :openCreateModal="handleOpenModalRef"
                      ref="classe_imposto"
                    />
                  </div>
                  <InputQuant
                    label="Quant."
                    type="text"
                    style="width: 10% !important"
                    :dataInput.sync="produtosNotaFiscal.quantidade"
                    @changed="formatTotalProductValue"
                    ref="quantidade"
                    :decimalPlaces="decimalPlaces"
                  />
                  x
                  <InputMoney
                    style="width: 15% !important"
                    label="Valor Unitário"
                    labelFixed
                    ref="refVlUnit"
                    type="text"
                    :dataInput.sync="produtosNotaFiscal.subtotal"
                    @calculateTotal="formatTotalProductValue"
                  />
                  =
                  <InputMoney
                    style="width: 15% !important"
                    label="Valor Total"
                    labelFixed
                    ref="valorTotal"
                    type="text"
                    isDisabled
                    :dataInput.sync="produtosNotaFiscal.total"
                    @calculateTotal="formatTotalProductValue"
                  />

                  <InputMoney
                    style="width: 15% !important"
                    v-if="!discountIsCheked"
                    label="Desconto"
                    :labelFixed="true"
                    type="text"
                    :dataInput.sync="produtosNotaFiscal.desconto"
                    ref="discount"
                    @calculateTotal="formatTotalProductValue"
                  />
                  <InputPercentage
                    v-else
                    style="width: 15% !important"
                    label="% Desconto"
                    :labelFixed="true"
                    type="text"
                    :dataInput.sync="produtosNotaFiscal.desconto"
                    ref="discount"
                    @calculateTotal="formatTotalProductValue"
                  />
                  <div class="itemToggleDesc">
                    <label class="switch">
                      <input
                        type="checkbox"
                        ref="typeDiscount"
                        @click="alterDiscountIsCheked"
                        v-model="discountIsCheked"
                      />
                      <div class="slider">
                        <span>R$</span>
                        <span>%</span>
                      </div>
                    </label>
                  </div>
                </div>
                <div class="rowContent">
                  <div class="input-group" style="width: 100% !important">
                    <input
                      required
                      class="input borderInput"
                      v-model="produtosNotaFiscal.informacoes_adicionais"
                    />
                    <label class="user-label"> Dados Adicionais </label>
                  </div>
                  <b-button
                    class="btnsSave"
                    style="width: 120px !important"
                    @click="saveOrUpdateNotaItems"
                    >Adicionar</b-button
                  >
                </div>

                <div class="ContentTable">
                  <table style="width: 100%">
                    <thead
                      style="
                        background-color: #3a4750 !important;
                        color: whitesmoke;
                        text-align: center;
                        height: 27px;
                      "
                    >
                      <tr>
                        <th>Nome Produto</th>
                        <th>Quantidade</th>
                        <th>Vl. unitario</th>
                        <th>Vl. total</th>
                        <th>Desconto</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody style="color: #3a4750; width: 100%">
                      <tr
                        v-for="notaItem in produtosForTable"
                        :key="notaItem.id"
                        style="text-align: center; height: 27px"
                      >
                        <td>{{ notaItem.nome }}</td>
                        <td>{{ notaItem.quantidade }}</td>
                        <td>
                          {{
                            notaItem.subtotal.toLocaleString("pt-br", {
                              style: "currency",
                              currency: "BRL",
                            })
                          }}
                        </td>
                        <td>
                          {{
                            notaItem.total.toLocaleString("pt-br", {
                              style: "currency",
                              currency: "BRL",
                            })
                          }}
                        </td>
                        <td>
                          {{
                            notaItem.desconto
                              ? notaItem.desconto.toLocaleString("pt-br", {
                                  style: "currency",
                                  currency: "BRL",
                                })
                              : "0,00"
                          }}
                        </td>
                        <td>
                          <b-button
                            size="sm"
                            variant="light"
                            style="color: black"
                            @click="editProductsOfSale(notaItem.id)"
                            v-b-popover.hover.right="{
                              variant: 'secondary',
                              content: 'Editar',
                            }"
                          >
                            <b-icon-pencil-square></b-icon-pencil-square
                          ></b-button>
                          <b-button
                            size="sm"
                            variant="light"
                            style="color: red"
                            :disabled="
                              responseNfeWebMania.status === 'aprovado' ||
                              responseNfeWebMania.status === 'processamento'
                                ? true
                                : false
                            "
                            @click="deleteProductFromNote(notaItem.id)"
                            v-b-popover.hover.right="{
                              variant: 'secondary',
                              content: 'Excluir',
                            }"
                          >
                            <b-icon-x-circle></b-icon-x-circle
                          ></b-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-card>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
    </b-card-text>

    <b-card-text class="mt-3" :hidden="dadosNfe.operacao == '0' ? true : false">
      <div>
        <b-navbar toggleable class="cardDadosNfe">
          <b-navbar-toggle
            target="navbar-toggle-collapse-pedido"
            id="dadosNfeStyle"
            class="tamanhoCards"
          >
            <template #default="{ expanded }">
              <div class="tamanhoBotaoOpenCard">
                <div>
                  <b-icon
                    v-if="expanded"
                    icon="dash-square-fill"
                    style="color: #00395d"
                  ></b-icon>
                  <b-icon v-else icon="plus-square-fill" style="color: #00395d">
                  </b-icon>
                </div>
                <div style="margin-left: 10px; font-size: 13px">
                  Dados Pedido
                </div>
              </div>
            </template>
          </b-navbar-toggle>

          <b-collapse
            id="navbar-toggle-collapse-pedido"
            class="col-md-12 col-sm-12 col-lg-12 col-xl-12"
            is-nav
          >
            <b-navbar-nav class="ml-auto">
              <b-card class="mt-2 cardDadosNfeBorda">
                <div class="rowContent">
                  <div class="selectPlus">
                    <label class="user-label-disabled"
                      >Condição de Pagamento</label
                    >
                    <b-form-select
                      class="borderInput shadow-none"
                      value-field="value"
                      text-field="text"
                      v-model="dadosNfe.pagamento"
                      :options="pagamento"
                    >
                    </b-form-select>
                  </div>
                  <div class="selectPlus">
                    <label class="user-label-disabled"
                      >Forma de Pagamento</label
                    >
                    <b-form-select
                      class="borderInput shadow-none"
                      value-field="value"
                      text-field="text"
                      @change="selectedPayment"
                      v-model="dadosNfe.forma_pagamento"
                      :options="forma_pagamento"
                    >
                    </b-form-select>
                  </div>
                  <div class="selectPlus">
                    <label class="user-label-disabled">Presença</label>
                    <b-form-select
                      class="borderInput shadow-none"
                      value-field="value"
                      text-field="text"
                      v-model="dadosNfe.presenca"
                      :options="presenca"
                    >
                    </b-form-select>
                  </div>
                  <div class="input-group" style="width: 13% !important">
                    <b-form-input
                      class="input borderInput"
                      disabled
                      @change="calculateTotalAndTotalDiscount"
                      @keypress="defineMaxLengthDiscount"
                      :value="maskCurrency(dadosNfe.desconto)"
                      @input="handleTotalDiscount"
                    />
                    <label class="user-label-disabled"> Desconto </label>
                  </div>
                  <div class="input-group" style="width: 13% !important">
                    <b-form-input
                      class="input borderInput"
                      disabled
                      :value="handleTotalValue(dadosNfe.total)"
                    />
                    <label class="user-label-disabled"> Valor Total </label>
                  </div>
                </div>

                <div class="mt-3">
                  <p class="descriptionObs">Informações complementares</p>

                  <textarea
                    class="inputTextArea"
                    rows="3"
                    max-rows="6"
                    v-model="dadosNfe.informacoes_complementares"
                  />
                </div>

                <div class="rowContent" v-if="exibirDadosIntermediador">
                  <div class="selectPlus">
                    <label class="user-label-disabled">Intermediador</label>
                    <b-form-select
                      class="borderInput shadow-none"
                      value-field="value"
                      text-field="text"
                      v-model="dadosNfe.intermediador"
                      :options="intermediador"
                    >
                    </b-form-select>
                  </div>
                  <div class="input-group">
                    <input
                      required
                      class="input borderInput"
                      v-model="dadosNfe.id_intermediador"
                    />
                    <label class="user-label"> Nome do Intermediador </label>
                  </div>
                  <div class="input-group">
                    <input
                      required
                      class="input borderInput"
                      v-model="dadosNfe.cnpj_intermediador"
                    />
                    <label class="user-label"> CNPJ do Intermediador </label>
                  </div>
                </div>
              </b-card>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
    </b-card-text>

    <b-card-text class="mt-3" :hidden="dadosNfe.operacao == '0' ? true : false">
      <div>
        <b-navbar toggleable class="cardDadosNfe" style="margin-bottom: 100px">
          <b-navbar-toggle
            target="navbar-toggle-collapse-duplicatas"
            id="dadosNfeStyle"
            class="tamanhoCards"
          >
            <template #default="{ expanded }">
              <div class="tamanhoBotaoOpenCardFinaly">
                <div>
                  <b-icon
                    v-if="expanded"
                    icon="dash-square-fill"
                    style="color: #00395d"
                  ></b-icon>
                  <b-icon v-else icon="plus-square-fill" style="color: #00395d">
                  </b-icon>
                </div>
                <div style="margin-left: 10px; font-size: 13px">Duplicatas</div>
              </div>
            </template>
          </b-navbar-toggle>

          <b-collapse
            id="navbar-toggle-collapse-duplicatas"
            class="col-md-12 col-sm-12 col-lg-12 col-xl-12"
            is-nav
          >
            <b-navbar-nav>
              <b-card class="mt-2 cardDadosNfeBordaDupli">
                <div class="rowContent" v-if="!dadosNfe.idVenda">
                  <div class="input-group">
                    <input
                      type="date"
                      class="input borderInput"
                      v-model="duplicates.fistExpiration"
                    />
                    <label class="user-label"> Data do 1º Vencimento </label>
                  </div>
                  <div class="selectPlus">
                    <label class="user-label-disabled">Tipo de Pagamento</label>
                    <b-form-select
                      class="borderInput shadow-none"
                      value-field="id"
                      text-field="tipo"
                      :options="typePayments"
                      v-model="duplicates.idTypePayment"
                    >
                    </b-form-select>
                  </div>
                  <div class="selectPlus">
                    <label class="user-label-disabled"
                      >Conta de recebimento</label
                    >
                    <b-form-select
                      class="borderInput shadow-none"
                      value-field="id"
                      text-field="nome"
                      :options="receiptAccounts"
                      v-model="duplicates.idReceiptAccount"
                    >
                    </b-form-select>
                  </div>
                  <div class="input-group">
                    <input
                      class="input borderInput"
                      v-model="duplicates.dateInterval"
                    />
                    <label class="user-label"> Intervalo de Vencimento </label>
                  </div>
                  <div class="input-group">
                    <input
                      class="input borderInput"
                      v-model="duplicates.installments"
                    />
                    <label class="user-label"> Quantidade de Parcelas </label>
                  </div>
                </div>

                <div class="ContentTable">
                  <table style="width: 100%">
                    <thead
                      style="
                        color: whitesmoke;
                        background: #3a4750;
                        text-align: center;
                        height: 27px;
                      "
                    >
                      <tr>
                        <th>Data vencimento</th>
                        <th>Forma</th>
                        <th>Valor da parcela</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody style="color: #3a4750; width: 100%">
                      <tr
                        style="text-align: center; height: 27px"
                        v-for="bill in billsFromTable"
                        :key="bill.id"
                      >
                        <td>{{ bill.data | formatDate }}</td>
                        <td>{{ bill.formaPagamento }}</td>
                        <td>{{ maskCurrency(bill.valorTotal) }}</td>
                        <td v-if="!dadosNfe.idVenda">
                          <b-button
                            :disabled="dadosNfe.idVenda ? true : false"
                            size="sm"
                            variant="light"
                            style="color: red"
                            v-b-popover.hover.right="{
                              variant: 'secondary',
                              content: 'Excluir',
                            }"
                            @click="deleteBill(bill.id)"
                          >
                            <b-icon-x-circle></b-icon-x-circle
                          ></b-button>
                        </td>
                        <td v-else>-</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  class="rowContent"
                  style="margin-top: 30px"
                  v-if="!dadosNfe.idVenda"
                >
                  <div class="btnsContainer">
                    <b-button
                      style="padding: 5px"
                      class="btnsSaveNeutral"
                      @click="getAllBillsByIdNota"
                      >Fechar</b-button
                    >
                    <b-button
                      class="btnsSave"
                      style="padding: 5px"
                      @click="makingThePayment"
                      >Lançar Pagamento</b-button
                    >
                  </div>
                </div>
              </b-card>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
    </b-card-text>
    <div class="rowContentFooter">
      <div class="btnsContainerFooterInit">
        <b-button class="btnsSaveNeutral" @click="clearInputs"
          >Nova NFC-e</b-button
        >
        <b-button
          v-if="this.dadosNfe.id"
          class="btnsSave"
          @click="updateOrSaveNotaFiscal"
          >Atualizar</b-button
        >
        <b-button
          v-if="!this.dadosNfe.id"
          class="btnsSave"
          @click="updateOrSaveNotaFiscal"
          >Salvar</b-button
        >
      </div>
      <div class="btnsContainerFooter">
        <b-button
          class="btnsSave"
          v-if="this.dadosNfe.id"
          @click="previewNote()"
          >Pré-Visualização</b-button
        >
        <b-button
          class="btnsSave"
          v-if="
            responseNfeWebMania.status === 'aprovado' ||
            responseNfeWebMania.status === 'processamento'
          "
          @click="printNfce(dadosNfe.id)"
          >Visualizar</b-button
        >

        <b-button
          style="position: relative"
          class="btnsSave"
          :disabled="
            loadginSendNfe ||
            dadosNfe.status === 'Processamento' ||
            dadosNfe.status === 'Contingência'
          "
          v-if="dadosNfe.id"
          @click.stop="atributeIdSale()"
          >Emitir
          <b-spinner
            v-if="loadginSendNfe"
            style="
              width: 15px;
              height: 15px;
              position: absolute;
              right: 5px;
              top: 25%;
            "
            variant="primary"
        /></b-button>

        <b-dropdown
          text="Ações"
          class="btnsAction"
          variant="light"
          style="color: white"
          v-if="this.dadosNfe.id"
        >
          <template #button-content>
            <b-icon-gear></b-icon-gear>
          </template>
          <b-dropdown-item
            :disabled="
              dadosNfe.status === 'Cancelada' || dadosNfe.status === ''
                ? true
                : false
            "
            @click="openModals('modalCancelNota')"
            >Cancelar
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <ModalCreateCustomer
      :idCustomerFromSearch="dadosNfe.idCliente"
      @getAllNewCustomer="handleCreatedNewCustomer"
    />

    <ModalCreateProduct
      :idProductFromSearch="idProductFromSearch"
      @getAllNewProduct="handleCreatedNewProduct"
    />

    <ModalTaxInformation
      @createdNewRef="createdNewRef = $event"
      @closeModal="handleCloseModalRef"
      :refFromSearch="refFromSearch"
    />

    <ModalCancelNota
      :idNota="{
        uuidNotaWebMania: responseNfeWebMania.uuid,
        idNota: dadosNfe.id,
      }"
      @getNotaAfterCanceled="findNotaById"
    />
  </div>
</template>

<script>
import moment from "moment";
import { mapMutations, mapState } from "vuex";

import ModalCreateCustomer from "../../components/Modals/ModalCreateCustomer.vue";
import ModalCreateProduct from "../../components/Modals/ModalCreateProduct.vue";
import ModalTaxInformation from "../../components/ModalTaxInformation/Index-TaxInformation.vue";
import ModalCancelNota from "../../components/NotaFiscal/ModalCancelNota.vue";
import InputQuant from "../../components/UI/CustomInputs/InputQuant.vue";
import InputInfinit from "../../components/UI/CustomInputs/InputInfinit.vue";
import InputSelect from "../../components/UI/CustomInputs/InputSelect.vue";
import InputPercentage from "../../components/UI/CustomInputs/InputPercentage.vue";
import InputMoney from "../../components/UI/CustomInputs/InputMoney.vue";

import ServiceCustomer from "../../services/serviceCustomer";
import ServiceProducts from "../../services/serviceProducts";
import ServiceNotaFiscal from "../../services/serviceNotaFiscal";
import ServiceTax from "../../services/serviceTax";
import ServicePaymentForm from "../../services/servicePaymentForm";
import ServiceAccountReceiptBill from "../../services/serviceAccountReceiptBill";
import ServiceBill from "../../services/serviceBill";
import ServiceSettings from "../../services/serviceSettings";
import ServiceNotaItem from "../../services/serviceNotaItem";
import toastAlertErros from "../../utils/toastAlertErros";
import { HandleErrors } from "../../utils/handleErrors";
import { TypeErrors } from "../../utils/enums/TypeErrors";
import { BillColumnsToSearchById } from "../../utils/enums/BillColumnsToSearchById";
import { mascaraMoeda, maskPercentage } from "../../utils/maskMoney";
import { unidade } from "../../common/index";
export default {
  components: {
    ModalCreateCustomer,
    ModalCreateProduct,
    ModalTaxInformation,
    ModalCancelNota,
    InputInfinit,
    InputQuant,
    InputSelect,
    InputPercentage,
    InputMoney,
  },
  props: {
    dataNFeAfterTransformSaleToNfe: {
      type: Object,
    },
  },
  data() {
    return {
      dadosNfe: {
        id: "",
        id_webmania: "",
        operacao: "1",
        idVenda: "",
        natureza_operacao: "Venda de mercadoria",
        modelo: 2, //2 para NFC-e
        ambiente: "2", //2 para Homologação 1 para Produção
        idCliente: "",
        finalidade: 1,
        data_nfe: moment().format("YYYY-MM-DD HH:mm"),
        response: "",
        response_cancelamento: "",
        status: "",
        pagamento: 0,
        forma_pagamento: "01",
        presenca: 1,
        modalidade_frete: 9,
        frete: 0.0,
        desconto: 0.0,
        total: "",
        intermediador: "",
        cnpj_intermediador: "",
        id_intermediador: "",
        informacoes_complementares: "",
      },
      responseNfeWebMania: {
        chave: "",
        danfe: "",
        danfe_etiqueta: "",
        danfe_simples: "",
        log: "",
        modelo: "",
        motivo: "",
        nfe: "",
        serie: "",
        status: "",
        uuid: "",
        xml: "",
      },
      responseNfeWebManiaCancelamento: {
        log: {},
        status: "",
        xml: "",
      },
      produtosNotaFiscal: {
        idProduto: "",
        idNota: "",
        codigo: "",
        ncm: "",
        cest: "",
        quantidade: 1,
        unidade: "",
        peso: "",
        origem: 0,
        desconto: 0,
        subtotal: "",
        total: "",
        classe_imposto: "",
        informacoes_adicionais: "",
      },
      produtos: [],
      produtosForTable: [],
      pagamento: [
        { value: 0, text: "Pagamento à vista" },
        { value: 1, text: "Pagamento à prazo" },
      ],
      forma_pagamento: [
        { value: "01", text: "Dinheiro" },
        { value: "02", text: "Cheque" },
        { value: "03", text: "Cartão de Crédito" },
        { value: "04", text: "Cartão de Débito" },
        { value: "05", text: "Crédito Loja" },
        { value: "10", text: "Vale Alimentação" },
        { value: "11", text: "Vale Refeição" },
        { value: "12", text: "Vale Presente" },
        { value: "13", text: "Vale Combustível" },
        { value: "14", text: "Duplicata Mercantil" },
        { value: "15", text: "Boleto Bancário" },
        { value: "16", text: "Depósito Bancário" },
        { value: "17", text: "Pagamento Instantâneo (PIX)" },
        { value: "18", text: "Transferência bancária, Carteira Digital" },
        {
          value: "19",
          text: "Programa de fidelidade, Cashback, Crédito Virtual",
        },
        { value: "90", text: "Sem pagamento" },
      ],
      presenca: [
        {
          value: 0,
          text: "0 - Não se aplica (por exemplo, Nota Fiscal complementar ou de ajuste)",
        },
        { value: 1, text: "1 - Operação presencial" },
        { value: 2, text: "2 - Operação não presencial, pela Internet" },
        { value: 3, text: "3 - Operação não presencial, Teleatendimento" },
        { value: 4, text: "4 - NFC-e em operação com entrega a domicílio" },
        { value: 5, text: "5 - Operação presencial, fora do estabelecimento" },
        { value: 9, text: "9 - Operação não presencial, outros" },
      ],
      modelo: [
        { value: 1, text: "NFE" },
        { value: 2, text: "NFCE" },
      ],
      ambiente: [
        { value: 1, text: "Produção" },
        { value: 2, text: "Homologação" },
      ],
      isDisabled: true,
      intermediador: [
        {
          value: 0,
          text: "0 - Operação sem intermediador (em site ou plataforma própria)",
        },
        {
          value: 1,
          text: "1 - Operação em site ou plataforma de terceiros (intermediadores/marketplace)",
        },
      ],
      allRefsFiscaisFromSelectBox: [],
      classeImpostoDevolucao: "",
      createdNewRef: false,
      duplicates: {
        dateInterval: "",
        installments: "",
        fistExpiration: "",
        idTypePayment: "",
        idReceiptAccount: "",
      },
      typePayments: [],
      receiptAccounts: [],
      billsFromTable: [],
      getNewFormPayment: false,
      idProductFromSearch: "",
      loadginSendNfe: false,
      newOrder: false,
      createdNewCustomer: false,
      createdNewProducts: false,
      toggleClearSelect: false,
      unidade: unidade,
      idNota: "",
      refFromSearch: "",
      discountIsCheked: false,
      maskPercentage: maskPercentage,
    };
  },
  methods: {
    ...mapMutations(["SET_DATA_NFE"]),
    async clearInputs() {
      this.newOrder = !this.newOrder;
      this.dadosNfe.id = "";
      this.dadosNfe.id_webmania = "";
      this.$refs.quantidade.valueInput = 1;
      this.dadosNfe.natureza_operacao = "Venda de mercadoria";
      await this.getConfig();
      this.dadosNfe.idCliente = "";
      this.dadosNfe.data_nfe = moment().format("YYYY-MM-DD HH:mm");
      this.dadosNfe.status = "";
      this.dadosNfe.informacoes_complementares = "";

      this.produtosNotaFiscal.idProduto = "";
      this.produtosNotaFiscal.codigo = "";
      this.produtosNotaFiscal.quantidade = 1;
      this.produtosNotaFiscal.informacoes_adicionais = "";
      this.produtosNotaFiscal.subtotal = 0.0;
      this.produtosNotaFiscal.total = 0.0;
      this.produtosNotaFiscal.unidade = "";
      this.produtosNotaFiscal.peso = "";
      this.produtosNotaFiscal.ncm = "";
      this.produtosNotaFiscal.origem = 0;
      this.produtosNotaFiscal.desconto = "";
      this.produtosNotaFiscal.classe_imposto = "";
      this.toggleClearSelect = !this.toggleClearSelect;

      this.dadosNfe.modalidade_frete = 9;
      this.dadosNfe.frete = 0.0;
      this.dadosNfe.pagamento = 0;
      this.dadosNfe.forma_pagamento = "01";
      this.dadosNfe.presenca = 1;
      this.dadosNfe.desconto = 0.0;
      this.dadosNfe.total = 0.0;
      this.dadosNfe.intermediador = "";
      this.dadosNfe.id_intermediador = "";
      this.dadosNfe.cnpj_intermediador = "";

      this.produtosForTable = [];
      this.billsFromTable = [];

      this.responseNfeWebMania.chave = "";
      this.responseNfeWebMania.danfe = "";
      this.responseNfeWebMania.danfe_etiqueta = "";
      this.responseNfeWebMania.danfe_simples = "";
      this.responseNfeWebMania.log = "";
      this.responseNfeWebMania.modelo = "";
      this.responseNfeWebMania.motivo = "";
      this.responseNfeWebMania.nfe = "";
      this.responseNfeWebMania.serie = "";
      this.responseNfeWebMania.status = "";
      this.responseNfeWebMania.uuid = "";
      this.responseNfeWebMania.xml = "";

      this.SET_DATA_NFE({});
    },

    enableFreightage() {
      this.dadosNfe.modalidade_frete == 9
        ? (this.isDisabled = true)
        : (this.isDisabled = false);
    },

    handleTotalValue(value) {
      this.dadosNfe.total = value;
      return this.maskCurrency(this.dadosNfe.total);
    },

    async alterDiscountIsCheked() {
      this.discountIsCheked = !this.discountIsCheked;
      this.formatTotalProductValue();
    },

    formatTotalProductValue() {
      const amount = Number(this.produtosNotaFiscal.quantidade);
      const unitaryValue = this.produtosNotaFiscal.subtotal;
      const totalValue = amount * unitaryValue;

      if (!this.$refs.valorTotal) return;

      this.produtosNotaFiscal.total = totalValue;

      let desconto = 0;

      if (this.discountIsCheked) {
        const discount = (
          this.produtosNotaFiscal.total *
          (this.produtosNotaFiscal.desconto / 100)
        ).toFixed(2);
        desconto = parseFloat(discount);
      } else {
        desconto = this.produtosNotaFiscal.desconto;
      }
      // this.$refs.discount.valueInput = desconto;
      this.$refs.valorTotal.valueInput = totalValue - desconto;
    },

    calculateTotalAndTotalDiscount() {
      if (this.produtosForTable.length > 0) {
        const valorTotalNota = this.produtosForTable
          .map((produto) => parseFloat(produto.total))
          .reduce((total, preco) => total + preco, 0);

        this.dadosNfe.total = parseFloat(valorTotalNota);

        this.dadosNfe.desconto = this.produtosForTable
          .map((produto) => parseFloat(produto.desconto))
          .reduce((total, desconto) => total + desconto, 0);
      } else {
        this.dadosNfe.total = 0;
        this.dadosNfe.desconto = 0;
      }
    },

    selectedPayment() {
      this.updateNotaFiscal();
    },

    async fillCustomerComboBoxWithPaginate(id, q, filterType, page) {
      try {
        return await ServiceCustomer.fillComboBoxWithPaginate(
          id,
          q,
          filterType,
          page
        );
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao listar os clientes",
          type: "info",
        });
      }
    },

    async fillProductsComboBoxWithPaginate(id, q, filterType, page) {
      try {
        return await ServiceProducts.fillComboBoxWithPaginate(
          id,
          q,
          filterType,
          page
        );
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao listar os produtos",
          type: "info",
        });
      }
    },

    handleDataCustomers(event) {
      this.dataCustomers = [event];
    },

    handleCreatedNewProduct() {
      this.createdNewProducts = !this.createdNewProducts;
    },

    handleCreatedNewCustomer() {
      this.createdNewCustomer = !this.createdNewCustomer;
    },

    defineMaxLengthDiscount() {
      if (this.dadosNfe.desconto?.length > 4) {
        this.dadosNfe.desconto = this.dadosNfe.desconto.slice(0, 4);
      }
    },

    handleModalCreateProduct(nameModal, idProduct) {
      this.idProductFromSearch = idProduct;
      this.openModals(nameModal);
    },

    openModals(idModal) {
      this.$bvModal.show(idModal);
    },

    async printNfce(id) {
      try {
        const danfe = await ServiceNotaFiscal.printNfce(id);

        const win = window.open(
          danfe,
          "_blank",
          "width=700, height=800, top=500, left=500"
        );

        win.document.write(danfe);

        win.document.close();
      } catch (error) {
        this.$toast.open({
          message: "Ocorreu um erro ao abrir o arquivo",
          type: "info",
        });
      }
    },

    async sendNota() {
      await this.sendExitNota();
    },

    async previewNote() {
      try {
        const resultPreview = await ServiceNotaFiscal.previewNote(
          this.dadosNfe.id
        );
        window.open(resultPreview.dataWebMania.danfe, "_blank");
      } catch (error) {
        return this.$toast.open({
          message: error.response.data.message || "Erro ao pré-visualizar nota",
          type: "info",
        });
      }
    },

    atributeIdSale() {
      if (!this.dadosNfe.idCliente) {
        return this.$toast.open({
          message: "É necessário selecionar um cliente para emitir a nota!",
          type: "warning",
        });
      }
      this.idNota = this.dadosNfe.id;
      this.sendCoupon(true);
    },

    async sendCoupon(isLeaveClient) {
      try {
        this.spinLoading = true;
        const data = await ServiceNotaFiscal.sendCoupon(
          null,
          isLeaveClient,
          this.idNota
        );
        if (data.id) {
          await this.printNfce(data.id);
        }

        return this.$toast.open({
          message: "Cupom Fiscal emitido com sucesso!",
          type: "success",
        });
      } catch (error) {
        console.log(error);
        const typeError = HandleErrors(error?.response?.data?.message);

        if (typeError && typeError?.nameError === TypeErrors.NO_PERMISSIONS) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }

        return this.$toast.open({
          message:
            error?.response?.data?.message ||
            error?.response?.data?.erros ||
            "Ops! Houve algum erro. Verifique os dados e tente novamente",
          type: "info",
        });
      } finally {
        this.spinLoading = false;
      }
    },

    async sendExitNota() {
      try {
        await ServiceNotaFiscal.updateNota({
          ...this.dadosNfe,
          total: this.dadosNfe.total,
          desconto: this.dadosNfe.desconto,
        });

        const result = await ServiceNotaFiscal.sendExitNota(this.dadosNfe.id);
        Object.assign(this.responseNfeWebMania, result.dataWebMania);
        this.dadosNfe.status = result.status;

        await this.printNfce(this.dadosNfe.id);
        if (result.status === "Contingência") {
          return this.$toast.open({
            message:
              "Nota em contingência, deve-se aguardar, a nota será emitida em breve!",
            type: "info",
          });
        } else {
          return this.$toast.open({
            message: "Nota emitida com sucesso!",
            type: "success",
          });
        }
      } catch (error) {
        const typeError = HandleErrors(error?.response?.data?.message);

        if (
          (typeError && typeError?.nameError === TypeErrors.NO_PERMISSIONS) ||
          typeError?.nameError === TypeErrors.NOT_FOUND_SOFTWARE_PLAN ||
          typeError?.nameError === TypeErrors.NOT_FOUND_FISCAL_DOCUMENTS
        ) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }

        this.$toast.open({
          message: error?.response?.data?.message,
          type: "info",
        });
      }
    },

    saveOrUpdateNotaItems() {
      !this.produtosNotaFiscal.id
        ? this.saveProductInNote()
        : this.updateNotaItems();
    },

    async updateNotaItems() {
      try {
        const formatedSubTotal = this.produtosNotaFiscal.subtotal;
        const formatedTotal = parseFloat(this.$refs.valorTotal.valueInput);
        let formatedDesconto = 0;
        if (this.discountIsCheked) {
          const discount = (
            this.produtosNotaFiscal.total *
            (this.produtosNotaFiscal.desconto / 100)
          ).toFixed(2);
          formatedDesconto = parseFloat(discount);
        } else {
          formatedDesconto = this.produtosNotaFiscal.desconto;
        }
        await ServiceNotaItem.updateNotaItems({
          ...this.produtosNotaFiscal,
          idNota: this.dadosNfe.id,
          subtotal: formatedSubTotal,
          total: formatedTotal,
          desconto: formatedDesconto,
        });
        await this.findProductsByIdNota();
        await this.updateNotaFiscal();
        this.clearProducts();

        this.$emit("getAllInvoices", this.getInvoices);
        this.getInvoices = !this.getInvoices;

        return this.$toast.open({
          message: "Produto atualizado!",
          type: "success",
        });
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else toastAlertErros.validateMessage(error, this.$toast);
      }
    },

    async saveProductInNote() {
      try {
        if (this.dadosNfe.id === "") {
          return this.$toast.open({
            message: "É necessário salvar a nota para adicionar o produto!",
            type: "warning",
          });
        } else {
          const formatedSubTotal = this.produtosNotaFiscal.subtotal;
          const formatedTotal = parseFloat(this.$refs.valorTotal.valueInput);

          let formatedDesconto = 0;
          if (this.discountIsCheked) {
            const discount = (
              this.produtosNotaFiscal.total *
              (this.produtosNotaFiscal.desconto / 100)
            ).toFixed(2);
            formatedDesconto = parseFloat(discount);
          } else {
            formatedDesconto = this.produtosNotaFiscal.desconto;
          }
          await ServiceNotaFiscal.saveNotaItem({
            ...this.produtosNotaFiscal,
            idNota: this.dadosNfe.id,
            subtotal: formatedSubTotal,
            total: formatedTotal,
            desconto: formatedDesconto,
          });

          await this.findProductsByIdNota();
          await this.updateNotaFiscal();
          this.clearProducts();
        }
      } catch (error) {
        console.log(error);
        return toastAlertErros.validateErrorRemoveUnwantedCharacters(
          error,
          this.$toast
        );
      }
    },

    clearProducts() {
      this.produtosNotaFiscal.id = "";
      this.produtosNotaFiscal.idProduto = "";
      this.produtosNotaFiscal.codigo = "";
      this.produtosNotaFiscal.quantidade = 1.0;
      this.produtosNotaFiscal.informacoes_adicionais = "";
      this.produtosNotaFiscal.subtotal = "";
      this.produtosNotaFiscal.total = "";
      this.produtosNotaFiscal.unidade = "";
      this.produtosNotaFiscal.peso = "";
      this.produtosNotaFiscal.ncm = "";
      this.produtosNotaFiscal.origem = 0;
      this.produtosNotaFiscal.desconto = "";
      this.produtosNotaFiscal.classe_imposto = "";

      this.refFromSearch = "";

      this.$refs.classe_imposto.valueItems = "";

      this.$refs.quantidade.valueInput = "1";
      this.toggleClearSelect = !this.toggleClearSelect;
      this.$refs.discount.valueInput = 0;
      this.$refs.valorTotal.valueInput = 0;
      this.$refs.refVlUnit.valueInput = 0;
    },

    async deleteProductFromNote(id) {
      try {
        await ServiceNotaFiscal.deleteItemFromNote(id);
        await this.findProductsByIdNota();

        await this.updateOrSaveNotaFiscal(false);
      } catch (error) {
        return this.$toast.open({
          message:
            error.response.data.message || "Não foi possível deletar o produto",
          type: "warning",
        });
      }
    },

    async findProductsByIdNota() {
      const result = await ServiceNotaFiscal.findProductsByIdNota(
        this.dadosNfe.id
      );

      this.produtosForTable = result.noteItem;

      this.calculateTotalAndTotalDiscount();
    },

    async assignValuesToTheSelectedProduct(event) {
      if (!this.produtosNotaFiscal.id) {
        event && (this.produtos = [event]);

        const result = this.produtos.filter(
          (idProduto) => idProduto.id == this.produtosNotaFiscal.idProduto
        );

        if (result && result.length) {
          this.produtosNotaFiscal.unidade = result[0].unidade;
          this.produtosNotaFiscal.codigo = result[0].codReferencia;
          this.produtosNotaFiscal.classe_imposto = result[0].refFiscal;
          this.produtosNotaFiscal.ncm = result[0].ncm;
          this.produtosNotaFiscal.cest = result[0].cest;
          this.produtosNotaFiscal.subtotal = result[0].valorVenda;
          this.$refs.refVlUnit.valueInput = result[0].valorVenda;
          this.formatTotalProductValue();
        }
      }
    },

    async editProductsOfSale(id) {
      try {
        const result = await ServiceNotaItem.findById(id);

        this.$refs.discount.valueInput = result.noteItem.desconto;
        this.$refs.valorTotal.valueInput = result.noteItem.total;
        this.$refs.refVlUnit.valueInput = result.noteItem.subtotal;
        this.$refs.classe_imposto.valueItems = result.noteItem.classe_imposto;

        Object.assign(this.produtosNotaFiscal, result.noteItem);
      } catch (error) {
        return this.$toast.open({
          message:
            error.response.data.message || "Não foi possível Editar o produto",
          type: "warning",
        });
      }
    },

    async getProductsById() {
      try {
        const data = await ServiceProducts.getProductById(
          this.produtosNotaFiscal.idProduto
        );
        return data;
      } catch (error) {
        return this.$toast.open({
          message: "Não foi possível buscar o produto",
          type: "warning",
        });
      }
    },

    async saveNotaFiscal(showToast = true) {
      try {
        if (!this.dadosNfe.idCliente) {
          return this.$toast.open({
            message: "É necessário selecionar um cliente!",
            type: "warning",
          });
        }
        const result = await ServiceNotaFiscal.saveNota({
          ...this.dadosNfe,
          total: this.dadosNfe.total,
        });

        this.dadosNfe.id = result.id;
        this.$emit("getAllInvoices", this.getInvoices);
        this.getInvoices = !this.getInvoices;

        if (showToast)
          return this.$toast.open({
            message: "Nota Fiscal salva!",
            type: "success",
          });
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else
          toastAlertErros.validateErrorRemoveUnwantedCharacters(
            error,
            this.$toast
          );
      }
    },

    async updateNotaFiscal(showToast = true) {
      try {
        if (!this.dadosNfe.idCliente) {
          return this.$toast.open({
            message: "É necessário selecionar um cliente!",
            type: "warning",
          });
        }
        await ServiceNotaFiscal.updateNota({
          ...this.dadosNfe,
          total: this.dadosNfe.total,
          desconto: this.dadosNfe.desconto,
        });

        this.$emit("getAllInvoices", this.getInvoices);
        this.getInvoices = !this.getInvoices;

        if (showToast)
          return this.$toast.open({
            message: "Nota Fiscal atualizada!",
            type: "success",
          });
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else toastAlertErros.validateMessage(error, this.$toast);
      }
    },

    clickProductAndSave() {
      if (this.dadosNfe.id === "" && this.dadosNfe.idCliente !== "") {
        this.updateOrSaveNotaFiscal();
      }
    },

    async updateOrSaveNotaFiscal(showToast = true) {
      this.dadosNfe.id !== ""
        ? this.updateNotaFiscal(showToast)
        : this.saveNotaFiscal(showToast);
    },

    async handleEmitOrReturnNota() {
      this.loadginSendNfe = true;

      if (!this.produtosForTable.length) {
        return this.$toast.open({
          message:
            "Produtos devem ser informados para processeguir com a emissão",
          type: "info",
        });
      }

      await this.sendNota();

      this.loadginSendNfe = false;
    },

    async findNotaById() {
      const result = await ServiceNotaFiscal.findNotaById(this.dadosNfe.id);
      Reflect.deleteProperty(result, "idEmpresa");

      Object.assign(this.dadosNfe, result, {
        total: String(result?.total)?.toLocaleString("pt-br", {
          minimumFractionDigits: 2,
        }),
      });

      Object.assign(this.responseNfeWebMania, result.response);
      Object.assign(
        this.responseNfeWebManiaCancelamento,
        result.response_cancelamento
      );
    },

    async findAllRefsFromSelectBox() {
      try {
        const result = await ServiceTax.findAllRefs();
        this.allRefsFiscaisFromSelectBox = result.data.map((e) => {
          return {
            id: e.id,
            descricao: `${e.ref} - ${e.descricao}`,
            ref: e.ref,
            refObject: e.refObject,
          };
        });
      } catch (error) {
        console.log(error);
      }
    },

    async makingThePayment() {
      try {
        if (this.dadosNfe.id === "") {
          return this.$toast.open({
            message: "Selecione uma nota para lançar as duplicatas",
            type: "warning",
          });
        }

        const bill = [];

        const totalValue = this.dadosNfe.total;
        const valuePerDuplicates = totalValue / this.duplicates.installments;
        for (let i = 0; i < this.duplicates.installments; i++) {
          const expirationDate =
            i == 0
              ? this.duplicates.fistExpiration
              : moment(expirationDate)
                  .add(this.duplicates.dateInterval, "days")
                  .format("YYYY-MM-DD");
          bill.push({
            tipo: "entrada",
            idCliente: this.dadosNfe.idCliente,
            idFormaPagamento: this.duplicates.idTypePayment,
            idContaRecebimento: this.duplicates.idReceiptAccount,
            idNota: this.dadosNfe.id,
            valorTotal: valuePerDuplicates,
            valorPago: 0.0,
            valorRestante: 0.0,
            data: expirationDate,
            dataCompetencia: moment().format("YYYY-MM-DD"),
          });
        }

        const formData = new FormData();
        formData.append("data", JSON.stringify(bill));
        await ServiceBill.save(formData);

        this.getAllBillsByIdNota();

        return this.$toast.open({
          message: "Parcela Registrada!",
          type: "success",
        });
      } catch (error) {
        return this.$toast.open({
          message:
            error.response.data.message ||
            "Verifique se os campos estão preenchidos corretamente!",
          type: "warning",
        });
      }
    },

    async getAllBillsByIdNota() {
      try {
        const data = await ServiceBill.getAllBillsByParamsId(
          this.dadosNfe.id,
          BillColumnsToSearchById.idNota
        );
        this.billsFromTable = data;
      } catch (error) {
        console.log(error.response);
        return this.$toast.open({
          message: "Ocorreu um erro ao listas as duplicatas",
          type: "error",
        });
      }
    },

    async deleteBill(id) {
      try {
        await ServiceBill.deleteAllRelationshipsFromDuplicate(id);
        await this.getAllBillsByIdNota();

        return this.$toast.open({
          message: "Duplicata deletada com sucesso",
          type: "success",
        });
      } catch (error) {
        return this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao excluir essa conta!",
          type: "info",
        });
      }
    },

    async getPaymentsFromSelectBox() {
      const result = await ServicePaymentForm.getAllPayment();
      this.typePayments = result;
    },

    async getReceiptBillForSelectBox() {
      const result = await ServiceAccountReceiptBill.fillComobobox();
      this.receiptAccounts = result;
    },

    assignMonetaryValueSaleToNfe() {
      const totalNFe = this.dataNFeAfterTransformSaleToNfe.nfe.total;
      const totalDiscount = this.dataNFeAfterTransformSaleToNfe.nfe.desconto;

      const data = {
        ...this.dataNFeAfterTransformSaleToNfe.nfe,
        data_nfe: moment().format("YYYY-MM-DD HH:mm"),
        total: totalNFe,
        desconto: totalDiscount,
      };

      return data;
    },

    handleOpenModalRef() {
      this.openModals("modalTaxInformation");

      this.refFromSearch = this.produtosNotaFiscal.classe_imposto;
    },

    handleCloseModalRef() {
      this.refFromSearch = "";
    },

    maskToKg(valor, locale = "pt-BR") {
      if (!valor) {
        valor = 0;
      }

      return `KG ${parseFloat(valor).toLocaleString(locale, {
        minimumFractionDigits: 2,
      })}`;
    },

    maskCurrency(valor, locale = "pt-BR") {
      if (!valor) {
        valor = 0;
      }

      return parseFloat(valor).toLocaleString(locale, {
        style: "currency",
        currency: "BRL",
      });
    },

    handleSubtotalMonetaryValue(event) {
      this.produtosNotaFiscal.subtotal = mascaraMoeda(event.target.value);
    },

    handleDiscountProductsValue(event) {
      this.produtosNotaFiscal.desconto = mascaraMoeda(event.target.value);
    },

    handleTotalDiscount(event) {
      this.dadosNfe.desconto = mascaraMoeda(event.target.value);
    },

    handleEditNFe() {
      if (Object.keys(this.dataNFe).length) {
        Object.assign(this.dadosNfe, this.dataNFe);
        this.produtosForTable = this.dataNFe.products;
        this.billsFromTable = this.dataNFe.bills;

        if (this.dataNFe.response) {
          this.responseNfeWebMania = { ...this.dataNFe.response };
        }
      }
    },

    async getConfig() {
      const result = await ServiceSettings.findSettingsAtm();
      if (Object.keys(result).length) {
        this.dadosNfe.ambiente = result.emissao_fiscal.ambiente;
      }
    },
  },
  computed: {
    ...mapState(["dataNFe", "dataConfig"]),
    exibirDadosIntermediador() {
      return this.retornaTipoOperacao && this.retorntaTipoPresenca;
    },
    retornaTipoOperacao() {
      return this.dadosNfe.operacao == 1;
    },
    retorntaTipoPresenca() {
      return (
        this.dadosNfe.presenca == 2 ||
        this.dadosNfe.presenca == 3 ||
        this.dadosNfe.presenca == 4 ||
        this.dadosNfe.presenca == 9
      );
    },
    handleButtonEmitirNfe() {
      if (
        (this.dadosNfe.nfe_referenciada !== "" &&
          this.dadosNfe.id !== "" &&
          this.responseNfeWebMania?.chave === "" &&
          this.dadosNfe.operacao == "0") ||
        this.responseNfeWebMania?.status === "reprovado" ||
        this.responseNfeWebMania.status === "contingencia"
      ) {
        return false;
      } else {
        if (
          this.produtosForTable.length < 1 ||
          this.responseNfeWebMania?.chave !== ""
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    handleOperacao() {
      return this.dadosNfe.operacao;
    },
    decimalPlaces() {
      if (Object.keys(this.dataConfig)?.length) {
        return Number(this.dataConfig?.venda_mtq?.casas_decimais);
      }

      return 2;
    },
  },
  filters: {
    formatDate: function (value) {
      return moment(value).format("DD/MM/YYYY");
    },
  },
  mounted() {
    this.handleEditNFe();
    this.enableFreightage();
    this.findAllRefsFromSelectBox();
    this.getPaymentsFromSelectBox();
    this.getReceiptBillForSelectBox();
    this.getConfig();
  },
  beforeDestroy() {
    this.clearInputs();
  },
  watch: {
    createdNewRef() {
      this.findAllRefsFromSelectBox();
    },
  },
};
</script>

<style scoped>
.containerGeralNfe {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 12px;
}

.conteudoDadosNfe {
  border-radius: 5px;
  padding: 0 !important;
  margin-top: 10px;
}

.cardDadosNfe {
  padding-bottom: 15px !important;
  border-radius: 5px !important;
  border: 1px solid rgba(232, 231, 231, 0.788);
  background-color: #f9f9f94d !important;
  padding: 0px 0px 0px 0px !important;
  border-radius: 5px !important;
  width: 100%;
}

.cardDadosNfeBorda {
  border-radius: 5px !important;
  margin-top: 25px !important;
  margin-bottom: 20px;
}

.itemToggleDesc {
  width: 55px;
  height: 30px;
  position: relative;
  display: flex;
}

/* The slider */

.switch {
  height: 100%;
  margin: 0;
  font-size: 14px;
  position: relative;
  display: inline-block;
}

.slider {
  position: absolute;
  cursor: pointer;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: #d9d9d9;
  color: #ffffff;
  border-radius: 50px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  transition: 0.4s;
  width: 50px !important;
  height: 90%;
  font-size: 8px;
}

.slider:before {
  position: absolute;
  content: "R$";
  font-size: 10px;
  height: 82%;
  width: 44%;
  left: 6%;
  border-radius: 50px;
  background-color: #00aa62;
  color: white;
  display: grid;
  align-content: center;
  justify-content: center;
  transition: 0.4s;
  font-weight: bold;
}

.slider:after {
  content: "";
  position: absolute;
  z-index: -1;
}

.switch input:checked + .slider {
  background-color: #d9d9d9;
  color: white;
}

.switch input:checked + .slider:before {
  content: "%";
  background-color: #00aa62;
  transform: translateX(100%);
  color: white;
}

.switch input {
  display: none;
}

.iconSelectBarCode {
  position: absolute;
  right: 0px !important;
  z-index: 10;
  background-color: #c1c1c1;
  color: black;
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
  cursor: pointer;
}
.cardDadosNfeBordaDupli {
  border-radius: 5px !important;
  margin-top: 25px !important;
  margin-bottom: 80px;
}

.tamanhoCards {
  width: 100%;
  display: flex;
}

.dropdown-menu {
  display: none;
  font-size: 12px;
  color: #212529;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu li {
  font-size: 12px;
  width: 100% !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  display: flex;
  text-align: center;
  list-style: none;
  border: none;
  height: 20px;
}

.ContentTable {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 30px;
}

tr:nth-child(even) {
  background: #f2f3f3;
}

td {
  text-transform: capitalize;
}

.tamanhoBotaoOpenCard {
  color: black;
  font-size: 16px;
  height: 30px;
  display: flex;
  align-items: center;
}

.tamanhoBotaoOpenCardFinaly {
  color: black;
  font-size: 16px;
  height: 30px;
  display: flex;
  align-items: center;
}
.titleModal {
  font-size: 1rem;
  border-bottom: 1px solid #e6e7e8;
  font-weight: bold;
}

.btnModal {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.btnContent {
  font-size: 11px;
  border: 1px solid #00486e;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #00486e;
}

.btnContentReceive {
  font-size: 11px;
  border: 1px solid #00486e;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #00486e;
  background: white;
}
.chkSaidaEntrada {
  margin-top: 18px;
}

.spin {
  width: 80vw;
  display: flex;
  height: 100vh;
  top: 0;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 10000;
}

.containerCheckBox {
  display: flex;
  height: 30.1px !important;
  width: 125px !important;
  align-items: center !important;
  border: solid 1px rgb(216, 215, 215);
  border-radius: 5px;
  padding-left: 15px !important;
  margin-right: 16px;
}

.iconCadTransportadora {
  display: flex;
  justify-content: space-between;
}

.btnCadTransportadora {
  cursor: pointer;
}

.tableReturnProducts {
  margin-top: 31px;
  overflow: auto !important;
  max-height: 300px;
  text-align: center;
}

.tdReturnProducts {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

#dadosNfeStyle {
  border: none !important;
}

.btnFormaPagamento {
  cursor: pointer;
}

.form-control-sm {
  height: 28px;
  padding: 0.25rem 0.25rem;
  font-size: 12px;
  line-height: 1.3;
  border-radius: 0.2rem;
}

.custom-select-sm {
  height: 28px;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 12px;
}

@media screen and (max-width: 438px) {
  .contentDataNfeRow {
    display: flex;
    flex-direction: column;
  }
}

@media screen and (max-width: 388px) {
  .additionalButtonContent {
    display: flex;
    flex-direction: column;
  }
}

.form-control-sm {
  height: 28px;
  padding: 0.25rem 0.25rem;
  font-size: 12px;
  line-height: 1.3;
  border-radius: 0.2rem;
}

.form-group {
  margin-bottom: 0.2rem;
}

span {
  font-weight: bold;
  cursor: context-menu;
}

.user-label {
  position: absolute;
  left: 10px;
  font-size: 11px;
  bottom: 7px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
  z-index: 10;
}

.user-label-sm {
  position: absolute;
  left: 130px;
  font-size: 11px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.input {
  font-size: 12px !important;
  width: 100%;
}

.input:focus ~ label,
input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.1em;
}

.selectPlus {
  position: relative;
  width: 30%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.selectPlusSm {
  position: relative;
  width: 20%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.fixedSelect {
  position: absolute;
  margin-bottom: 0px;
  font-size: 9px;
  bottom: 23px;
  left: 10px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: transparent;
}

.user-label-disabled {
  position: absolute;
  left: 10px;
  font-size: 9px;
  bottom: 22px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
  background-color: #ffffff;
}

.user-label-data {
  position: absolute;
  left: 0px;
  font-size: 11px;
  bottom: 7px;
  pointer-events: none;
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
  background-color: #ffffff;
}

.fixedSelect2 {
  position: absolute;
  margin-bottom: 0px;
  font-size: 10px;
  bottom: 22px;
  left: 11px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: white;
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 11px !important;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: none;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.borderInput {
  font-size: 12px !important;
  height: 30px;
  border: 1px solid #d5d3d3;
  border-radius: 5px !important;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.borderInput:focus {
  box-shadow: none !important;
  border: 1px solid #505050;
}

.title {
  font-size: 16px;
  color: rgb(95, 95, 95);
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgb(230, 230, 230);
  display: flex;
  justify-content: space-between;
}

.rowContainer {
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 10px 10px 5px 10px;
  background: #f9f9f94d;
  margin-bottom: 10px;
}

.rowContent {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  justify-content: space-between;
  gap: 10px;
}

.rowContentFooter {
  display: flex;
  width: 80vw;
  padding: 15px 10px 30px 10px;
  justify-content: space-between;
  gap: 10px;
  height: 60px;
  bottom: 0;
  background: #f9f9f9;
  position: fixed;
  z-index: 8000;
}

.rowObservation {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  height: 40px;
}

.btnsContainer {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.btnsContainerFooter {
  display: flex;
  width: 100%;
  gap: 20px;
  justify-content: flex-end;
  align-items: center;
}

.closeModal {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1000;
  color: rgb(255, 153, 153);
  cursor: pointer;
  border: 1px solid rgb(238, 238, 238);
  padding: 2px 3px;
  border-radius: 4px;
}

.closeModal:hover {
  color: red;
  background: rgba(245, 245, 245, 0.764);
}

.btnsContainerFooterInit {
  display: flex;
  width: 100%;
  gap: 20px;
  justify-content: flex-start;
  align-items: center;
}

.btnsSave {
  border-radius: 5px;
  background-color: #00395d;
  width: 165px;
  border: none;
  color: white;
  font-size: 12px;
}

.btnsAction {
  border-radius: 4px;
  width: 65px;
  border: 1px solid rgb(222, 221, 221);
  color: white;
  display: flex;
  font-size: 12px !important;
}

.btnsSaveNeutral {
  border-radius: 5px;
  background-color: #ececec;
  width: 165px;
  border: 1px solid rgb(222, 221, 221);
  color: rgb(0, 0, 0);
  font-size: 12px;
}

.input-group {
  width: 30%;
}

.input-group-time {
  width: 15%;
}

.input-groupSm {
  width: 20%;
}

.input-group-ob {
  width: 100%;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 0;
}

.descriptionObs {
  margin: 0px;
  color: #666360;
  font-weight: 600;
  font-family: Poppins-Regular, sans-serif !important;
  font-size: 11px;
}

.inputTextArea {
  width: 100%;
  border: none;
  outline: none;
  text-decoration: none;
  background-color: white;
  color: #5c5855;
  border-radius: 5px;
  height: 60px;
  padding-left: 5px;
  border: solid 1px #d9d9d9;
  resize: none;
}

.card {
  border: none !important;
}

.inputNameShippingCompany {
  width: 70%;
}

@media screen and (max-width: 800px) {
  .rowContentShippingCompany {
    flex-wrap: wrap;
    justify-content: start;
  }

  .inputNameShippingCompany {
    width: 100%;
  }

  .inputShippingCompanyMd {
    width: 48.82%;
    margin-top: 10px;
  }

  .inputShippingCompanySm {
    width: 32%;
  }
}

@media screen and (max-width: 700px) {
  .rowContent {
    flex-direction: column;
  }
  .selectPlus {
    width: 100%;
  }
  .input-group {
    width: 100% !important;
  }
  .selectPlusSm {
    width: 100%;
  }
  .input-groupSm {
    width: 100%;
  }
  .user-label-sm {
    left: 30px !important;
  }
  .rowContentFooter {
    display: flex;
    width: 100vw !important;
    padding: 5px;
    gap: 5px;
    height: 60px;
    bottom: 0;
  }
  .btnsSave {
    width: 100px;
    font-size: 11px;
  }
  .btnsSaveNeutral {
    width: 100px;
    font-size: 11px;
  }
}
</style>